import React, { useEffect, useState } from "react";
import { useMyContext } from "../../../../../screens/GSTModule/GstrForms/GstrThreeB/ContextApi";
import GstrThreeBInvoiceTable from "../GstrThreeBInvoiceTable";
import { getGstrThreeBDataTemplate } from "../../../../../constant/tableHeadersConstants/gst/gstr3bConstant";
import { TableHeadersType } from "../../../../../constant/tableHeadersConstants/tableHeadersType";
import { GstrThreeBDataType } from "../../../../../commonTypes/gstTypes";
type AppProps = {
  tableHeaderData: TableHeadersType[];
  gstrThreeBData: GstrThreeBDataType | {};
  type?: string;
  singleHeader: string;
};
const Gstr3bThreePointOneTableData = ({
  tableHeaderData,
  type,
  gstrThreeBData,
  singleHeader,
}: AppProps) => {
  const { handleGstrThreeBInvoiceListData, gstrThreeBInvoiceData } =
    useMyContext();
  const [showViewSource, setViewSource] = useState(false);
  const [showViewSourceIndex, setViewSourceIndex] = useState("");
  const [newGstrThreeBTableData, setNewGstrThreeBTableData] = useState<any>(
    structuredClone(
      getGstrThreeBDataTemplate(
        gstrThreeBData,
        gstrThreeBInvoiceData,
        singleHeader
      )
    )
  );

  const invoiceObjectKey = (name: string) => {
    if (
      gstrThreeBInvoiceData?.gstr3b_3_1 ||
      gstrThreeBInvoiceData?.gstr3b_3_1_1
    ) {
      if (name?.includes("(a)")) {
        return gstrThreeBInvoiceData?.gstr3b_3_1?.a;
      } else if (name?.includes("(b)")) {
        return gstrThreeBInvoiceData?.gstr3b_3_1?.b;
      } else if (name?.includes("(c)")) {
        return gstrThreeBInvoiceData?.gstr3b_3_1?.c;
      } else if (name?.includes("(d)")) {
        return gstrThreeBInvoiceData?.gstr3b_3_1?.d;
      } else if (name?.includes("(e)")) {
        return gstrThreeBInvoiceData?.gstr3b_3_1?.e;
      } else if (
        name?.includes(
          "Taxable supplies on which electronic commerce operator pays tax u/s 9(5) [to be furnished by electronic commerce operator]"
        )
      ) {
        return gstrThreeBInvoiceData?.gstr3b_3_1_1
          ?.electronic_commerce_operator_payment;
      } else if (
        name?.includes(
          "Taxable supplies made by registered person through electronic commerce operator, on which electronic commerce operator is required to pay tax u/s 9(5) [to be furnished by registered person making supplies through electronic commerce operator]"
        )
      ) {
        return gstrThreeBInvoiceData?.gstr3b_3_1_1
          ?.electronic_commerce_operator_payment_by_registered_person;
      }
    } else {
      return [];
    }
  };

  useEffect(() => {
    if (showViewSourceIndex) {
      const temp = structuredClone(newGstrThreeBTableData);
      const updatedData =
        !!temp?.data &&
        temp?.data?.map((data: any, index: number) => {
          if (index === +showViewSourceIndex) {
            temp.data[index].showViewSource = !data.showViewSource;
            temp.data[index].sourceData =
              type !== "3.1.1" && gstrThreeBInvoiceData?.gstr3b_3_1
                ? invoiceObjectKey(data?.natureOfSupplies)
                : gstrThreeBInvoiceData?.gstr3b_3_1_1
                ? invoiceObjectKey(data?.natureOfSupplies)
                : [];
          }
          return data;
        });
      const newUpdatedData = {
        data: updatedData,
      };
      setNewGstrThreeBTableData({ ...newUpdatedData });
    }
  }, [showViewSource, gstrThreeBInvoiceData]);

  return (
    <>
      {!!newGstrThreeBTableData?.data &&
        newGstrThreeBTableData?.data?.map((item: any, index: number) => {
          return (
            <>
              <tr key={item?.natureOfSupplies}>
                {tableHeaderData?.map((header: any) => {
                  if (header.value === "description") {
                    return (
                      <td style={{ width: "48%" }}>
                        <span> {item?.natureOfSupplies}</span>
                        {item?.isSource ? (
                          <span
                            style={{
                              color: "red",
                              marginLeft: "12px",
                              marginTop: "1px",
                              fontSize: "12px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              type === "3.1.1"
                                ? !gstrThreeBInvoiceData.hasOwnProperty(
                                    "gstr3b_3_1_1"
                                  ) && handleGstrThreeBInvoiceListData("3_1_1")
                                : !gstrThreeBInvoiceData.hasOwnProperty(
                                    "gstr3b_3_1"
                                  ) && handleGstrThreeBInvoiceListData("3_1");
                              setViewSource(!showViewSource);
                              setViewSourceIndex(index.toString());
                            }}
                          >
                            View Source
                          </span>
                        ) : null}
                      </td>
                    );
                  } else if (header.value === "total_count") {
                    return (
                      <td>
                        {item?.tableRowData?.total_count
                          ? item?.tableRowData?.total_count
                          : 0}
                      </td>
                    );
                  } else if (header.value === "total_taxable_value") {
                    return (
                      <td>
                        {item?.tableRowData?.total_taxable_value
                          ? item?.tableRowData?.total_taxable_value?.toFixed(2)
                          : 0}
                      </td>
                    );
                  } else if (header.value === "total_igst_amount") {
                    return (
                      <td>
                        {item?.tableRowData?.total_igst_amount
                          ? item?.tableRowData?.total_igst_amount?.toFixed(2)
                          : 0}
                      </td>
                    );
                  } else if (header.value === "total_cgst_amount") {
                    return (
                      <td>
                        {item?.tableRowData?.total_cgst_amount
                          ? item?.tableRowData?.total_cgst_amount?.toFixed(2)
                          : 0}
                      </td>
                    );
                  } else if (header.value === "total_sgst_amount") {
                    return (
                      <td>
                        {item?.tableRowData?.total_sgst_amount
                          ? item?.tableRowData?.total_sgst_amount?.toFixed(2)
                          : 0}
                      </td>
                    );
                  } else if (header.value === "cess") {
                    return (
                      <td>
                        {item?.tableRowData?.cess
                          ? item?.tableRowData?.cess?.toFixed(2)
                          : 0}
                      </td>
                    );
                  } else {
                    return <td>0</td>;
                  }
                })}
              </tr>
              {item?.showViewSource && (
                <GstrThreeBInvoiceTable
                  gstrThreeBInvoiceData={
                    item?.sourceData ? item?.sourceData : []
                  }
                />
              )}
            </>
          );
        })}
    </>
  );
};

export default Gstr3bThreePointOneTableData;
